import { api, unwrap } from './client';

export function listRoles() {
  return unwrap(api.get('/api/roles'));
}

export function listPermissions() {
  return unwrap(api.get('/api/roles/permissions'));
}

export function createRole(payload) {
  return unwrap(api.post('/api/roles', payload));
}

export function updateRole(id, payload) {
  return unwrap(api.put(`/api/roles/${id}`, payload));
}

export function deleteRole(id) {
  return unwrap(api.delete(`/api/roles/${id}`));
}
